import { transformStoryblokImg } from '../../utils'
import CardArticleSummary from '../common/cards/card-article-summary'
import Title from '../common/title'

const PopularPosts = ({ posts }) => {
  return (
    <div>
      <>
        <Title heading="h3" classNames="mb-8">
          Popular Posts
        </Title>
        {/* Check if posts array exists */}
        {posts && Array.isArray(posts) && posts.length > 0 ? (
          <div className="">
            {posts.map((post) => (
              <div className="pb-3">
                <CardArticleSummary
                  key={post.slug}
                  title={post.title}
                  p={post.excerpt}
                  img={post.featuredImage.node.sourceUrl}
                  href={'/blog/' + post.slug}
                  date={post.date}
                  height={200}
                  className="my-5"
                />
              </div>
            ))}
          </div>
        ) : (
          <p>No popular posts available.</p>
        )}
      </>
    </div>
  )
}

export default PopularPosts
